var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"move-text-hover",class:[
  _vm.isHoverMove ? 'is-hoverMove' : '',
  _vm.isRandomMove ? 'is-randomMove' : '',
  _vm.isPointer ? 'is-pointer' : '',
]},_vm._l((_vm.texts),function(t,i){return _c('span',{key:i,class:_vm.isRandom() ? 'randomMove' : ''},[_vm._v(_vm._s(t))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }